import React from "react";
import ReactTooltip from "react-tooltip";
import UserActivity from "../../types/admin/UserActivity";

import appIcon from "../../graphics/app.svg";

type ActivityListItemProps = {
    data: UserActivity;
};

class ActivityListItem extends React.Component<ActivityListItemProps> {
    componentDidMount(): void {
        ReactTooltip.rebuild();
    }

    render() {
        return (
            <span
                className="activity-list-item item"
                tabIndex={0}>
                <div className="user-icon">
                    <img
                        src={this.props.data.user?.profilePictureFile}
                        alt="User Icon"
                    />
                </div>
                <span>
                    {this.props.data.user?.firstName}{" "}
                    {this.props.data.user?.lastName}
                </span>
                {this.props.data.systems.map((system, index) => (
                    <div
                        className="app-icon"
                        key={index}
                        data-tip={`${
                            system.active ? "Actively using" : "Logged into"
                        } ${system.clientSystem?.name}`}
                        data-place="right">
                        <div
                            className={`border ${
                                system.active ? "active" : ""
                            }`}>
                            <img
                                src={system.clientSystem?.logoFile ?? appIcon}
                                alt="App Icon"
                            />
                        </div>
                    </div>
                ))}
            </span>
        );
    }
}

export default ActivityListItem;
